import {
	Icon,
	Tooltip,
} from '@salesforce/design-system-react/module/components';
import styles from './PrimaryCard.module.css';
import cx from 'classnames';
import { useMemo } from 'react';
import { startCase } from 'lodash';

type Props = {
	name: string;
	logo: string;
	status: string;
	isSelected?: boolean;
	onClick: any;
	listLength?: any;
};

const PrimaryCard: React.FC<Props> = ({
	name,
	logo,
	status,
	isSelected = false,
	listLength = undefined,
	onClick,
}) => {
	const iconClassNames = useMemo(() => {
		const s = status.toLocaleUpperCase();
		return cx({
			[styles.statusIndactorActive]: ['ACTIVE', 'OK'].includes(
				status.toLocaleUpperCase()
			),

			[styles.statusIndactorEngaged]: [
				'ENGAGED',
				'APPROVED',
				'UNDER_DEVELOPMENT',
				'ONGOING_INTEGRATION',
				'READY_FOR_ACTIVATION',
				'APPROVED_FOR_INTEGRATION',
			].includes(status.toLocaleUpperCase()),

			[styles.statusIndactorSuspended]: ['SUSPENDED', 'DEACTIVATED'].includes(
				status.toLocaleUpperCase()
			),

			[styles.statusIndactorDeactivated]: ['TERMINATED'].includes(
				status.toLocaleUpperCase()
			),
		});
	}, [status]);
	const alignToolTip = listLength == 1 ? 'left' : 'top';
	return (
		<div
			className={cx(
				'slds-grid slds-wrap slds-grid_vertical-align-center',
				styles.cardContainer,
				{
					[styles.isSelected]: isSelected,
					[styles.isStatusActive]: ['ACTIVE', 'OK'].includes(
						status.toLocaleUpperCase()
					),
					[styles.isStatusEngaged]: [
						'ENGAGED',
						'APPROVED',
						'UNDER_DEVELOPMENT',
					].includes(status.toLocaleUpperCase()),
					[styles.isStatusSuspended]: ['SUSPENDED', 'DEACTIVATED'].includes(
						status.toLocaleUpperCase()
					),
					[styles.isStatusDeactivated]: ['TERMINATED'].includes(
						status.toLocaleUpperCase()
					),
				}
			)}
			onClick={onClick}
			onKeyDown={()=>{return}}
		>
			<img className="slds-col slds-large-size_2-of-12" src={logo} />
			<div className={cx('slds-col slds-large-size_9-of-12')}>
				<div className="slds-grid slds-grid_align-spread">
					<span>{name}</span>
					<div>
						<Tooltip
							id="tooltip"
							align={alignToolTip}
							hoverCloseDelay={100}
							content={startCase(status.toLocaleLowerCase())}
							triggerClassName={styles.toolTip}
						>
							<span>
								<Icon
									category="utility"
									name="record"
									size="xx-small"
									className={iconClassNames}
								/>
							</span>
						</Tooltip>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PrimaryCard;
